export default __webpack_public_path__ + "static/media/nasa-Q1p7bh3SHj8-unsplash.ae8ebf5a.jpg";